import { useGoogleLogin } from "@react-oauth/google";
import { Divider, Grid, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { Facebook, Google, Microsoft } from "@mui/icons-material";
import * as React from "react";
import FacebookLogin from "@greatsumini/react-facebook-login";
import { useState } from "react";
import { useMsal } from "@azure/msal-react";

export const SingleSignOn = ({
  onSuccess,
  school = null,
  acceptedTerms = null,
  registration = false,
  exludeDivider = false,
}) => {
  const [helperText, setHelperText] = useState("");

  const { instance } = useMsal();
  const handleGoogleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      // Call backend mutation with the token
      await onSuccess("google", tokenResponse.access_token);
    },
    onError: (error) => {
      console.error("Google login failed", error);
    },
  });

  const handleFacebookLogin = (response) => {
    onSuccess("facebook", response.accessToken);
  };
  const handleMicrosoftLogin = async () => {
    if (!runValidation()) return;

    try {
      const response = await instance.loginPopup({
        scopes: ["User.Read"],
      });

      await onSuccess("microsoft", response.accessToken);
    } catch (err) {
      console.error("Microsoft login failed", err);
    }
  };

  const runValidation = () => {
    if (!registration) return true;
    if (!school || Object.keys(school).length === 0) {
      setHelperText("Please choose a school to continue");
      return false;
    }
    if (!acceptedTerms) {
      setHelperText("Please accept the Terms and Conditions to continue");
      return false;
    }
    setHelperText("");
    return true;
  };

  const handleGoogleClick = () => {
    if (runValidation()) {
      handleGoogleLogin(); // only triggers if validation passes
    }
  };

  // Wrap Facebook login
  const handleFacebookClick = (onClick) => () => {
    if (runValidation()) {
      onClick(); // only triggers Facebook login if validation passes
    }
  };

  return (
    <>
      <Grid item size={12}>
        {/* Google */}
        <Button
          fullWidth
          variant="outlined"
          startIcon={<Google />}
          onClick={handleGoogleClick}
          sx={{
            textTransform: "none",
            color: "#3c4043",
            borderColor: "#dadce0",
            "&:hover": {
              backgroundColor: "#f1f3f4",
              borderColor: "#c6c6c6",
            },
            px: 2,
            py: 1,
            minWidth: 160,
          }}
        >
          Google
        </Button>
      </Grid>
      <Grid item size={12}>
        <Button
          fullWidth
          variant="outlined"
          onClick={handleMicrosoftLogin}
          startIcon={<Microsoft />}
          sx={{
            textTransform: "none",
            color: "#fff",
            backgroundColor: "#2F2F7F",
            "&:hover": {
              backgroundColor: "#1f1f5f",
            },
            px: 2,
            py: 1,
            minWidth: 160,
          }}
        >
          Microsoft
        </Button>
      </Grid>
      <Grid item size={12}>
        {/* Facebook */}{" "}
        <FacebookLogin
          appId={process.env.REACT_APP_FACEBOOK_APP_ID}
          onSuccess={handleFacebookLogin}
          onFail={(error) => console.error("Facebook login failed", error)}
          render={({ onClick }) => (
            <Button
              fullWidth
              variant="contained"
              startIcon={<Facebook />}
              onClick={handleFacebookClick(onClick)} // <- wrapped version
              sx={{
                textTransform: "none",
                backgroundColor: "#1877F2",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "#165ecc",
                },
                px: 2,
                py: 1,
                minWidth: 160,
              }}
            >
              Facebook
            </Button>
          )}
        />
      </Grid>

      <Grid item size={12}>
        {helperText && (
          <Typography variant={"body2"} sx={{ color: "error.main" }}>
            {helperText}
          </Typography>
        )}
      </Grid>
      {!exludeDivider && (
        <Grid item size={12}>
          <Divider sx={{ mb: 1 }}>Or</Divider>
        </Grid>
      )}
    </>
  );
};
